import { axiosInstance } from './axios';
import { Job, AnalysisResponse } from '../../types/job';
import { authApi } from './auth';
import type { JobFilters } from '@/components/jobs/JobFilters';

interface JobSearchParams {
  query: string;
  location?: string;
  limit?: number;
  userId?: string;
  sortBy?: 'recent' | 'relevant';
  datePosted?: '1' | '7' | '30' | 'all';
  experienceLevel?: 'entry' | 'associate' | 'mid-senior' | 'director';
  jobType?: 'full_time' | 'part_time' | 'contract' | 'temporary' | 'internship';
  company?: string;
  remote?: boolean;
  easyApply?: boolean;
  salary?: boolean;
  minSalary?: number;
}

export const jobsApi = {
  // getJobs: async (skip: number = 0, limit: number = 15): Promise<{ jobs: Job[], total: number }> => {
  //   const user = await authApi.getCurrentUser();
  //   const response = await axiosInstance.get(`/jobs/user/${user.id}`, {
  //     params: { skip, limit }
  //   });
  //   return {
  //     jobs: response.data.jobs || [],
  //     total: response.data.total || 0
  //   };
  // },

  getJobs: async (skip: number = 0, limit: number = 10, filters?: JobFilters) => {
  try {
    const queryParams = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString(),
      ...(filters?.sortBy && { sort_by: filters.sortBy }),
      ...(filters?.datePosted && { date_posted: filters.datePosted }),
      ...(filters?.experienceLevel && { experience_level: filters.experienceLevel }),
      ...(filters?.jobType && { job_type: filters.jobType }),
      ...(filters?.location && { location: filters.location }),
      ...(filters?.company && { company: filters.company }),
      ...(filters?.title && { title: filters.title }),
      ...(filters?.remote !== undefined && { remote: filters.remote.toString() }),
    });
    const response = await  await axiosInstance.get(`/jobs?${queryParams}`);
    return {
      jobs: response.data.jobs || [],
      total: response.data.total || 0
    };
    } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
},

  searchJobs: async (params: JobSearchParams): Promise<Job[]> => {
    const response = await axiosInstance.post('/jobs/search', null, {
      params: {
        query: params.query.trim(),
        locations: params.location || 'Netherlands',
        limit: params.limit || 10,
        sort_by: params.sortBy || 'recent',
        date_posted: params.datePosted,
        experience_level: params.experienceLevel,
        job_type: params.jobType,
        company: params.company,
        remote: params.remote,
        easy_apply: params.easyApply,
        salary: params.salary,
        min_salary: params.minSalary
      }
    });
    return response.data;
  },

  getJobById: async (id: number): Promise<Job> => {
    const response = await axiosInstance.get(`/jobs/${id}`);
    return response.data;
  },

  analyzeCV: async (file: File, jobId?: number): Promise<AnalysisResponse> => {
    const formData = new FormData();
    formData.append('cv_file', file);

    const response = await axiosInstance.post(
      `/cv/analyze${jobId ? `?job_id=${jobId}` : ''}`, 
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  trackApplication: async (jobId: number, userId: string, status: 'to_apply' | 'applied' | 'archived') => {
    const response = await axiosInstance.post('/applications', {
      job_id: jobId,
      user_id: userId,
      status
    });
    return response.data;
  },

  getApplications: async (userId: string) => {
    const response = await axiosInstance.get('/applications', {
      params: { user_id: userId }
    });
    return response.data;
  },

  updateApplicationStatus: async (applicationId: number, userId: string, status: string, jobId: number) => {
    const response = await axiosInstance.patch(
      `/applications/${applicationId}`,
      { status, user_id: userId, job_id: jobId }
    );
    return response.data;
  },

  markJobNotInterested: async (jobId: number, userId: string): Promise<void> => {
    await axiosInstance.post(`/jobs/${jobId}/not-interested`, null, {
      params: { user_id: userId }
    });
  },

  removeJobNotInterested: async (jobId: number, userId: string): Promise<void> => {
    await axiosInstance.delete(`/jobs/${jobId}/not-interested`, {
      params: { user_id: userId }
    });
  },

  getNotInterestedJobs: async (userId: string): Promise<Job[]> => {
    const response = await axiosInstance.get(`/jobs/not-interested/${userId}`);
    return response.data;
  },

  createJob: async (jobData: any) => {
    const response = await axiosInstance.post('/jobs', jobData);
    return response.data;
  },
}; 